import { useLoaderData, useNavigate } from "react-router-dom";
import { ReservationCard, getReservationStatus, ReservationStatus } from "./Controls/ReservationCard";
import { PageTitle } from "./Controls/PageTitle";
import { Col, Container, Row } from "react-bootstrap";
import { Calendar2Check } from "react-bootstrap-icons";
import { Button } from "./Controls/Button";
import { Reservation } from "./Data/ApiTypes";

const STATUS_GROUP_ORDER: { key: ReservationStatus; label: string }[] = [
    { key: 'active',   label: 'Now'      },
    { key: 'upcoming', label: 'Upcoming'  },
    { key: 'expired',  label: 'Past'      },
];

function groupReservationsByStatus(reservations: Reservation[]): Map<ReservationStatus, Reservation[]> {
    const map = new Map<ReservationStatus, Reservation[]>();
    for (const r of reservations) {
        const status = getReservationStatus(r);
        const list = map.get(status) ?? [];
        list.push(r);
        map.set(status, list);
    }
    return map;
}

export function UserReservationsPage() {
    const nav = useNavigate();
    const reservations = useLoaderData() as Reservation[];
    const byStatus = groupReservationsByStatus(reservations);

    return <Container fluid>
        <Row>
            <Col>
                <PageTitle className="mb-1">
                    Reservations
                </PageTitle>
                {reservations.length === 0 && (
                    <div className="d-flex flex-column align-items-center text-center py-5 gap-3">
                        <div
                            className="rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: 64, height: 64, background: "rgba(214,31,132,0.1)" }}
                        >
                            <Calendar2Check style={{ fontSize: 28, color: "#D61F84" }} />
                        </div>
                        <div>
                            <div className="fw-semibold mb-1">No reservations yet</div>
                            <div className="text-muted small">Book hourly parking at a facility near you.</div>
                        </div>
                        <Button onClick={() => nav( "/" )}>
                            Find Parking
                        </Button>
                    </div>
                )}
                {STATUS_GROUP_ORDER.map(({ key, label }) => {
                    const group = byStatus.get(key);
                    if (!group || group.length === 0) return null;
                    return (
                        <div key={key} className="mb-4">
                            {key !== 'active' && <div className="text-muted small text-uppercase mb-2">{label}</div>}
                            {group.map(r => (
                                <ReservationCard key={r.reservationId} reservation={r} />
                            ))}
                        </div>
                    );
                })}
            </Col>
        </Row>
    </Container>;
}
